<!-- License Kinds and Endorsements Section -->
<div class="row ml-0 mr-0 lookup-user-license-wrap">
  <div class="panel-blue">
    <div class="header" (click)="toggleLicenseKindsPanel()" tabindex="0" role="button"
      [attr.aria-expanded]="showLicenseKindsPanel" aria-controls="lookupLicenseKindsPanel"
      aria-label="License Kinds and Endorsements section, toggle to expand or collapse">
      <span class="panel-title">License Kinds and Endorsements</span>
      <button type="button" class="toggle-panel" *ngIf="showLicenseKindsPanel"
        (click)="toggleLicenseKindsPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel" *ngIf="!showLicenseKindsPanel"
        (click)="toggleLicenseKindsPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupLicenseKindsPanel" *ngIf="showLicenseKindsPanel">
      <!-- Current License Kinds / Endorsements -->
      <div
        class="lookup-datagrid-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-2 position-relative"
        (click)="$event.stopPropagation()">
        <div class="current-license-kind-container">
          <h6 class="current-license-kind-title">Current License Kinds / Endorsements</h6>
        </div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div class="lookup-personal-grid-actions-wrap">
            <app-grid-actions [actions]="currentLicenseKindsActions"
              [showColumnChooser]="showCurrentLicenseKindsColumnChooser" [allColumns]="currentLicenseKindsAllColumns"
              [visibleColumns]="currentLicenseKindsColumnVisibility" (exportClick)="onCurrentLicenseKindsDownload()"
              (columnChooserToggle)="toggleCurrentLicenseKindsColumnChooser()"
              (columnToggle)="onCurrentLicenseKindsColumnToggle($event)"
              (columnChooserClose)="closeCurrentLicenseKindsColumnChooser()">
            </app-grid-actions>
          </div>
          <div class="endorsbtn-conatiner">
            <button *ngIf="showLicenseSentByEmailButton" class="btn email-primary"
              [pTooltip]="lookupGeneric['G0081'] || 'Send License by Email'" tooltipPosition="top"
              tooltipStyleClass="pcustom-tooltip" (click)="openSendLicenseByEmailModal()">
              <!-- <i class="fa fa-envelope-o" aria-hidden="true"></i> -->
              <span class="material-symbols-outlined" style="font-weight:300 !important;">mail</span>
            </button>

            <button type="button" class="reverse-extn-btn" *ngIf="showReverseExtersion" #reverseExtensionBtn
              (click)="onReverseExtension()">
              <i class="fa fa-undo mr-1" aria-hidden="true"></i> Reverse Extension
            </button>
            <span [matTooltip]="extendButtonTooltip" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              class="extend-tooltip-wrapper" *ngIf="showCurrentLKExtendBtn && !showReverseExtersion">
              <button type="button" class="extend-license-btn" (click)="onExtendLicense()"
                aria-label="Open extend license dialog" title="Extend License">
                Extend
              </button>
            </span>
            <!-- [disabled]="!isExtendButtonEnabled" -->
            <button type="button" class="btn btn-primary btn-sm add-endrosement-btn">
              <!-- (click)="onAddEndorsement()" -->
              <span class="material-symbols-outlined"> add_circle </span>
              Add Endorsement
            </button>
          </div>

        </div>
      </div>

      <!-- Add Endorsement Form -->
      <div *ngIf="showAddEndorsementForm" class="current-license-kind-form-container">

        <h6 class="add-endorsement-current-lic-title">Add Endorsement</h6>
        <form [formGroup]="addEndorsementForm" novalidate>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="license_type" class="form-label">License Type<span
                  class="requiredfield text-danger">*</span></label>
              <!-- <select id="license_type" class="formField" formControlName="licenseType"
                [ngClass]="{ 'is-invalid': addEndorsementForm.get('licenseType')?.invalid && addEndorsementForm.get('licenseType')?.touched }">
                <option [ngValue]="null" disabled selected>Select License Type</option>
                <option *ngFor="let option of licenseTypeOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div [matTooltip]="getSelectLabel(addEndorsementForm.get('licenseType')?.value, licenseTypeOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="license_type" [options]="licenseTypeOptions" formControlName="licenseType"
                  optionLabel="label" optionValue="value" placeholder="Select License Type" [filter]="true"
                  filterBy="label" styleClass="custom-req-dropdown" [ngClass]="{
                  'ng-invalid ng-dirty': addEndorsementForm.get('licenseType')?.invalid
                  && addEndorsementForm.get('licenseType')?.touched
                }">
                </p-dropdown>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="license_kind">License Kind<span class="requiredfield text-danger">*</span></label>
              <!-- <select id="license_kind" class="formField" formControlName="licenseKind"
                [ngClass]="{ 'is-invalid': addEndorsementForm.get('licenseKind')?.invalid && addEndorsementForm.get('licenseKind')?.touched }">
                <option [ngValue]="null" disabled selected>Select License Kind</option>
                <option *ngFor="let option of licenseKindOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div [matTooltip]="getSelectLabel(addEndorsementForm.get('licenseKind')?.value, licenseKindOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="license_kind" [options]="licenseKindOptions" formControlName="licenseKind"
                  optionLabel="label" optionValue="value" placeholder="Select License Kind" [filter]="true"
                  filterBy="label" styleClass="custom-req-dropdown" [ngClass]="{
                  'is-invalid': addEndorsementForm.get('licenseKind')?.invalid
                  && addEndorsementForm.get('licenseKind')?.touched
                }">
                </p-dropdown>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="endorsement_grade">Endorsement - Grade<span class="requiredfield text-danger">*</span></label>
              <!-- <select id="endorsement_grade" class="formField" formControlName="endorsementGrade"
                [ngClass]="{ 'is-invalid': addEndorsementForm.get('endorsementGrade')?.invalid && addEndorsementForm.get('endorsementGrade')?.touched }">
                <option [ngValue]="null" disabled selected>Select Endorsement-Grade</option>
                <option *ngFor="let option of endorsementTypeOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div
                [matTooltip]="getSelectLabel(addEndorsementForm.get('endorsementGrade')?.value, endorsementTypeOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="endorsement_grade" [options]="endorsementTypeOptions"
                  formControlName="endorsementGrade" optionLabel="label" optionValue="value"
                  placeholder="Select Endorsement-Grade" [filter]="true" filterBy="label"
                  styleClass="custom-req-dropdown"
                  [ngClass]="{ 'is-invalid': addEndorsementForm.get('endorsementGrade')?.invalid && addEndorsementForm.get('endorsementGrade')?.touched }">
                </p-dropdown>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="endorsement_pathway">Endorsement Pathway<span
                  class="requiredfield text-danger">*</span></label>
              <!-- <select id="endorsement_pathway" class="formField" formControlName="endorsementPathway"
                [ngClass]="{ 'is-invalid': addEndorsementForm.get('endorsementPathway')?.invalid && addEndorsementForm.get('endorsementPathway')?.touched }">
                <option [ngValue]="null" disabled selected>Select Endorsement Pathway</option>
                <option *ngFor="let option of endorsementPathwayOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div
                [matTooltip]="getSelectLabel(addEndorsementForm.get('endorsementPathway')?.value, endorsementPathwayOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="endorsement_pathway" [options]="endorsementPathwayOptions"
                  formControlName="endorsementPathway" optionLabel="label" optionValue="value"
                  placeholder="Select Endorsement Pathway" [filter]="true" filterBy="label"
                  styleClass="custom-req-dropdown" [ngClass]="{
                  'is-invalid': addEndorsementForm.get('endorsementPathway')?.invalid
                  && addEndorsementForm.get('endorsementPathway')?.touched
                }">
                </p-dropdown>
              </div>
            </div>
          </div>
          <div class="row ml-0 mr-0 mb-2">
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="effective_date">Effective Date<span class="requiredfield text-danger">*</span></label>
              <!-- <input type="date" id="effective_date" class="formField" formControlName="effectiveDate"
                [ngClass]="{ 'is-invalid': addEndorsementForm.get('effectiveDate')?.invalid && addEndorsementForm.get('effectiveDate')?.touched }"> -->
              <p-calendar id="effective_date" formControlName="effectiveDate" [showIcon]="true" dateFormat="mm/dd/yy"
                [minDate]="minDate" class="custom-due-date-cal" placeholder="MM/DD/YYYY"
                [ngClass]="{ 'ng-invalid ng-dirty': addEndorsementForm.get('effectiveDate')?.invalid && addEndorsementForm.get('effectiveDate')?.touched }">
              </p-calendar>
            </div>
          </div>
          <div class="row mb-2 fullWidth ml-0 mr-0 mt-2">
            <div class="col pr-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-outline-primary lookup-license-btn-cancel"
                (click)="onCancelAddEndorsement()">Cancel</button>
              <button type="button" class="btn btn-primary ml-2 lookup-license-btn-save"
                [disabled]="addEndorsementForm.invalid" (click)="onSaveAddEndorsementNew()">Save</button>
            </div>
          </div>
        </form>
      </div>

      <div class="tab-content border rounded  p-2" style="margin-left:0;margin-right:0;">
        <app-data-grid #currentLicenseKindsGrid [config]="currentLicenseKindsGridConfig" [activeTab]="'license'"
          [statusDataField]="'endorsementStatus'" [statusColorOverrides]="licenseKindStatusColorOverrides" [submittedStatusValues]="['Active']"
          [inactiveStatusValues]="['Inactive', 'Revoked', 'Suspended']" [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="lookup-user-license-action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper edit-wrapper">
                <button type="button" class="action-icon-button" pTooltip="Edit" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip" (click)="$event.stopPropagation()">
                  <!-- onEditLicenseKind(data) -->
                  <span class="material-symbols-outlined">edit_square</span>
                  <!-- <i class="fa fa-edit" aria-hidden="true"></i> -->
                </button>
              </span>
              <span class="action-span-wrapper delete-wrapper ml-2">
                <button type="button" class="action-icon-button deletebtn" pTooltip="Delete" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip" (click)="$event.stopPropagation()">
                  <!-- onDeleteLicenseKind(data); -->
                  <!-- <i class="fa fa-trash" aria-hidden="true"></i> -->
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>

      <!-- License Kinds and Endorsements History / Pending -->
      <div
        class="lookup-datagrid-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-2 position-relative"
        (click)="$event.stopPropagation()">
        <div class="license-kinds-endorsements-history-container">
          <h6 class="license-kinds-endorsements-history-title">License Kinds and Endorsements History / Pending</h6>
        </div>
        <div class="lookup-personal-grid-actions-wrap d-flex align-items-center gap-2">
          <app-grid-actions [actions]="licenseKindsHistoryActions"
            [showColumnChooser]="showLicenseKindsHistoryColumnChooser" [allColumns]="licenseKindsHistoryAllColumns"
            [visibleColumns]="licenseKindsHistoryColumnVisibility" (exportClick)="onLicenseKindsHistoryDownload()"
            (columnChooserToggle)="toggleLicenseKindsHistoryColumnChooser()"
            (columnToggle)="onLicenseKindsHistoryColumnToggle($event)"
            (columnChooserClose)="closeLicenseKindsHistoryColumnChooser()">
          </app-grid-actions>
        </div>
      </div>
      <div class="tab-content border rounded  p-2 mb-2" style="margin-left:0;margin-right:0;">
        <app-data-grid #licenseKindsHistoryGrid [config]="licenseKindsHistoryGridConfig" [activeTab]="'license'"
          [statusDataField]="'endorsementStatus'" [statusColorOverrides]="licenseKindStatusColorOverrides" [submittedStatusValues]="['Active']"
          [inactiveStatusValues]="['Inactive', 'Revoked', 'Suspended']" [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="lookup-user-license-action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper edit-wrapper">
                <button type="button" class="action-icon-button" pTooltip="Edit" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip" (click)="$event.stopPropagation()">
                  <!-- onEditLicenseKind(data); -->
                  <span class="material-symbols-outlined">edit_square</span>
                  <!-- <i class="fa fa-edit" aria-hidden="true"></i> -->
                </button>
              </span>
              <span class="action-span-wrapper delete-wrapper ml-2">
                <button type="button" class="action-icon-button deletebtn" pTooltip="Delete" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip" (click)="$event.stopPropagation()">
                  <!-- onDeleteLicenseKind(data); -->
                  <!-- <i class="fa fa-trash" aria-hidden="true"></i> -->
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Provisions Section -->
<div class="row ml-0 mr-0 lookup-user-license-wrap">
  <div class="panel-blue">
    <div class="header" (click)="toggleProvisionsPanel()" tabindex="0" role="button"
      [attr.aria-expanded]="showProvisionsPanel" aria-controls="lookupProvisionsPanel"
      aria-label="Provisions section, toggle to expand or collapse">
      <span class="panel-title">License Kind / Endorsement Provisions</span>
      <button type="button" class="toggle-panel" *ngIf="showProvisionsPanel"
        (click)="toggleProvisionsPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel" *ngIf="!showProvisionsPanel"
        (click)="toggleProvisionsPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupProvisionsPanel" *ngIf="showProvisionsPanel">
      <!-- Combined Provisions Toolbar -->
      <div
        class="lookup-datagrid-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-2 position-relative"
        (click)="$event.stopPropagation()">
        <div class="current-license-kind-container">
          <!-- <h6 class="current-license-kind-title">Provisions</h6> -->
        </div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center gap-2">
            <app-grid-actions [actions]="combinedProvisionsActions"
              [showColumnChooser]="showCombinedProvisionsColumnChooser" [allColumns]="combinedProvisionsAllColumns"
              [visibleColumns]="combinedProvisionsColumnVisibility" (exportClick)="onCombinedProvisionsDownload()"
              (columnChooserToggle)="toggleCombinedProvisionsColumnChooser()"
              (columnToggle)="onCombinedProvisionsColumnToggle($event)"
              (columnChooserClose)="closeCombinedProvisionsColumnChooser()">
            </app-grid-actions>
          </div>
          <button *ngIf="!showAddProvisionForm" type="button" class="btn btn-primary btn-sm add-endrosement-btn"
            (click)="onAddProvision()">
            <span class="material-symbols-outlined"> add_circle </span> Add Provision
          </button>
        </div>
      </div>

      <!-- Combined Add Provision Form -->
      <div *ngIf="showAddProvisionForm" class="current-license-kind-form-container">
        <h6 class="add-endorsement-current-lic-title">Add Provision</h6>
        <form [formGroup]="addCombinedProvisionForm" novalidate>
          <div class="row ml-0 mr-0">
            <!-- Category -->
            <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
              <label for="provision_category" class="form-label">Category<span
                  class="requiredfield text-danger">*</span></label>
              <p-dropdown inputId="provision_category" [options]="provisionCategoryOptions"
                formControlName="category" optionLabel="label" optionValue="value"
                placeholder="Select Category" styleClass="custom-req-dropdown"
                (onChange)="onProvisionCategoryChange($event)"
                [ngClass]="{ 'is-invalid': addCombinedProvisionForm.get('category')?.invalid && addCombinedProvisionForm.get('category')?.touched }">
              </p-dropdown>
              <div
                *ngIf="addCombinedProvisionForm.get('category')?.touched && addCombinedProvisionForm.get('category')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                Category is required.
              </div>
            </div>
            <!-- Source (License Kind or Endorsement based on category) -->
            <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
              <label for="combined_source" class="form-label">Source<span
                  class="requiredfield text-danger">*</span></label>
              <p-multiSelect inputId="combined_source" [options]="currentSourceOptions"
                formControlName="source"
                [disabled]="!addCombinedProvisionForm.get('category')?.value"
                placeholder="Select Source"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                [closeOnSelect]="false" display="chip" styleClass="custom-req-muliti-dropdown"
                (onChange)="onCombinedSourceChangeAdd($event)"
                [ngClass]="{ 'is-invalid': addCombinedProvisionForm.get('source')?.invalid && addCombinedProvisionForm.get('source')?.touched }">
              </p-multiSelect>
              <div
                *ngIf="addCombinedProvisionForm.get('source')?.touched && addCombinedProvisionForm.get('source')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                Source is required.
              </div>
            </div>
            <!-- Provision (options change based on category) -->
            <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
              <label for="combined_provision" class="form-label">Provision<span
                  class="requiredfield text-danger">*</span></label>
              <div [matTooltip]="getSelectLabel(addCombinedProvisionForm.get('provision')?.value, currentProvisionOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="combined_provision" [options]="currentProvisionOptions"
                  formControlName="provision" optionLabel="label" optionValue="value"
                  [placeholder]="placeholderMessage['P0146'] || 'Select Provision'" [filter]="true" filterBy="label"
                  filterMatchMode="contains" styleClass="custom-req-dropdown"
                  (onChange)="onAddCombinedProvisionChange($event)"
                  [disabled]="!addCombinedProvisionForm.get('category')?.value"
                  [ngClass]="{ 'is-invalid': addCombinedProvisionForm.get('provision')?.invalid && addCombinedProvisionForm.get('provision')?.touched }">
                </p-dropdown>
              </div>
              <div
                *ngIf="addCombinedProvisionForm.get('provision')?.touched && addCombinedProvisionForm.get('provision')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0184'] || 'Provision is required.'}}
              </div>
            </div>
            <!-- Due Date -->
            <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
              <label for="combined_due_date">Due Date<span class="requiredfield text-danger">*</span></label>
              <div class="input-group ssn-input-group calendar-icon-input">
                <input type="text" id="combinedProvDueDateInput" formControlName="dueDate" placeholder="Select Due Date"
                  data-placeholder="MM/DD/YYYY" class="form-control date-uppercase" maxlength="10"
                  (blur)="onProvDueDateChange(addCombinedProvisionForm.get('dueDate')?.value, null, addCombinedProvisionForm.get('category')?.value === 'License Kind' ? 'prolickind' : 'prolicendo')"
                  (input)="formatDateInput($event, addCombinedProvisionForm.get('dueDate'))" />
                <span class="ssn-eye">
                  <button type="button" class="btn p-0 eye" tabindex="7"
                    (click)="openDatePickerForControl($event, addCombinedProvisionForm.get('dueDate'), 'combinedProvDueDateInput', undefined, addCombinedProvisionForm.get('category')?.value === 'License Kind' ? 'prolickind' : 'prolicendo')"
                    (keypress)="openDatePickerForControl($event, addCombinedProvisionForm.get('dueDate'), 'combinedProvDueDateInput', undefined, addCombinedProvisionForm.get('category')?.value === 'License Kind' ? 'prolickind' : 'prolicendo')"
                    title="Open Calendar" aria-label="Open date picker">
                    <span class="material-symbols-outlined f-20 cal">calendar_month</span>
                  </button>
                </span>
              </div>
              <div *ngIf="addCombinedProvisionForm.get('dueDate')?.touched && addCombinedProvisionForm.get('dueDate')?.errors as errors"
                class="text-danger mt-1 err-font">
                <span *ngIf="errors['required']">Due Date is required.</span>
                <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">Enter a valid date in MM/DD/YYYY format.</span>
                <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
              </div>
              <div *ngIf="addCombinedProvisionForm.get('dueDate')?.touched && addCombinedProvisionForm.get('dueDate')?.errors?.['pastDateNotAllowed']"
                class="text-danger mt-1 err-font endorsementerrormsg">
                Date cannot be in the past.
              </div>
            </div>
            <!-- Additional Text -->
            <div class="col-sm-12 col-md-6 col-lg-4 relPos mb-2">
              <label for="combined_additional_text" class="form-label">Additional Text<span
                  class="requiredfield text-danger">*</span></label>
              <textarea rows="1" cols="30" pInputTextarea class="formField autoheighttextarea mb-0 mt-1"
                formControlName="additionalText" [placeholder]="placeholderMessage['P0148'] || 'Enter additional text'"
                maxlength="100"></textarea>
              <div
                *ngIf="addCombinedProvisionForm.get('additionalText')?.touched && addCombinedProvisionForm.get('additionalText')?.errors?.['required']"
                class="text-danger mt-1 err-font-textarea">
                {{errorMessages['M0197'] || 'Additional Text is required.'}}
              </div>
            </div>
          </div>
          <div class="row mb-2 fullWidth ml-0 mr-0 mt-2">
            <div class="col pr-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-outline-primary lookup-license-btn-cancel"
                (click)="onCancelAddProvision()">Cancel</button>
              <button type="button" class="btn btn-primary ml-2 lookup-license-btn-save"
                (click)="onSaveAddCombinedProvision()">Save</button>
            </div>
          </div>
        </form>
      </div>

      <!-- Combined Provisions Grid -->
      <div class="tab-content border rounded p-2 mb-2" style="margin-left:0;margin-right:0;">
        <app-data-grid #combinedProvisionsGrid [config]="combinedProvisionsGridConfig" [activeTab]="'license'"
          [statusDataField]="'status'" [submittedStatusValues]="['Active']"
          [statusColorOverrides]="provReqStatusColorOverrides"
          [inactiveStatusValues]="['Inactive', 'Revoked', 'Suspended']" [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="lookup-user-license-action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper edit-wrapper">
                <button type="button" class="action-icon-button" pTooltip="Edit" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip"
                  (click)="onEditCombinedProvision(data, $event)">
                  <span class="material-symbols-outlined">edit_square</span>
                </button>
              </span>
              <span class="action-span-wrapper delete-wrapper ml-2">
                <button type="button" class="action-icon-button deletebtn" pTooltip="Delete" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip"
                  (click)="onDeleteCombinedProvision(data, $event)">
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- License Requirements Section -->
<div class="row ml-0 mr-0 lookup-user-license-wrap">
  <div class="panel-blue">
    <div class="header" (click)="toggleLicenseRequirementsPanel()" tabindex="0" role="button"
      [attr.aria-expanded]="showLicenseRequirementsPanel" aria-controls="lookupLicenseRequirementsPanel"
      aria-label="License Requirements section, toggle to expand or collapse">
      <span class="panel-title">License Requirements</span>
      <button type="button" class="toggle-panel" *ngIf="showLicenseRequirementsPanel"
        (click)="toggleLicenseRequirementsPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel" *ngIf="!showLicenseRequirementsPanel"
        (click)="toggleLicenseRequirementsPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupLicenseRequirementsPanel" *ngIf="showLicenseRequirementsPanel">
      <div
        class="lookup-datagrid-toolbar d-flex justify-content-between align-items-center flex-wrap gap-2 py-2 px-2 position-relative"
        (click)="$event.stopPropagation()">
        <div class="current-license-kind-container">
          <!-- <h6 class="current-license-kind-title">License Requirements</h6>
          <div class="current-license-kind-divider"></div> -->
        </div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center gap-2">
            <app-grid-actions [actions]="licenseRequirementsActions"
              [showColumnChooser]="showLicenseRequirementsColumnChooser" [allColumns]="licenseRequirementsAllColumns"
              [visibleColumns]="licenseRequirementsColumnVisibility" (exportClick)="onLicenseRequirementsDownload()"
              (columnChooserToggle)="toggleLicenseRequirementsColumnChooser()"
              (columnToggle)="onLicenseRequirementsColumnToggle($event)"
              (columnChooserClose)="closeLicenseRequirementsColumnChooser()">
            </app-grid-actions>
          </div>

          <button *ngIf="!showAddLicenseRequirementForm" type="button"
            class="btn btn-primary btn-sm add-endrosement-btn" (click)="onAddLicenseRequirement()">
            <span class="material-symbols-outlined"> add_circle </span> Add License Requirement
          </button>
        </div>
      </div>

      <!-- Add License Requirement Form -->
      <div *ngIf="showAddLicenseRequirementForm" class="current-license-kind-form-container">
        <h6 class="add-endorsement-current-lic-title">Add License Requirement</h6>
        <form [formGroup]="addRequirementForm" novalidate>
          <div class="row ml-0 mr-0">
                        <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="requirement_type">Category<span class="requiredfield text-danger">*</span></label>
              <!-- <select id="requirement_type" class="formField" formControlName="type"
                [ngClass]="{ 'is-invalid': addRequirementForm.get('type')?.invalid && addRequirementForm.get('type')?.touched }"
                (change)="onRequirementTypeChange()">
                <option [ngValue]="null" disabled selected>Select Type</option>
                <option *ngFor="let option of requirementTypeOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div [matTooltip]="getSelectLabel(addRequirementForm.get('type')?.value, requirementTypeOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="requirement_type" [options]="requirementTypeOptions" formControlName="type"
                  optionLabel="label" optionValue="value" [placeholder]="placeholderMessage['P0150'] || 'Select Category'"
                  [filter]="true" filterBy="label" filterMatchMode="contains"
                  (onChange)="onRequirementTypeChange($event)" styleClass="custom-req-dropdown" [ngClass]="{
                  'is-invalid': addRequirementForm.get('type')?.invalid && addRequirementForm.get('type')?.touched  }">
                </p-dropdown>
              </div>
              <div
                *ngIf="addRequirementForm.get('type')?.touched && addRequirementForm.get('type')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0186'] || 'Type is required.'}}
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="requirement_license_kind">Source<span class="requiredfield text-danger">*</span></label>
              <p-multiSelect *ngIf="!showEndorsementField" [options]="getlicenseKindFilterOptions" formControlName="licenseKind"
                placeholder="Select Source" optionLabel="label"
                optionValue="value" [filter]="true" filterBy="label" [showClear]="true" [closeOnSelect]="false"
                display="chip" styleClass="custom-req-muliti-dropdown"
                [disabled]="!addRequirementForm.get('type')?.value"
                [ngClass]="{ 'is-invalid': addRequirementForm.get('licenseKind')?.invalid && addRequirementForm.get('licenseKind')?.touched }"
                (onChange)="onRequirementLicenseKindChange($event)">
              </p-multiSelect>
              <p-multiSelect *ngIf="showEndorsementField" [options]="getEndorsementTypeFilterOptions" formControlName="endorsement"
                [placeholder]="placeholderMessage['P0018'] || 'Select Endorsement'" optionLabel="label"
                optionValue="value" [filter]="true" filterBy="label" [showClear]="true" [closeOnSelect]="false"
                display="chip" styleClass="custom-req-muliti-dropdown"
                [ngClass]="{ 'is-invalid': addRequirementForm.get('endorsement')?.invalid && addRequirementForm.get('endorsement')?.touched }"
                (onChange)="onRequirementEndorsementChange($event)">
              </p-multiSelect>
              <div
                *ngIf="!showEndorsementField && addRequirementForm.get('licenseKind')?.touched && addRequirementForm.get('licenseKind')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0024'] || 'License Kind is required.'}}
              </div>
              <div
                *ngIf="showEndorsementField && (addRequirementForm.get('endorsement')?.touched || addRequirementForm.get('endorsement')?.dirty) && addRequirementForm.get('endorsement')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0025'] || 'Endorsement is required.'}}
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="requirement">Requirement<span class="requiredfield text-danger">*</span></label>
              <!-- <select id="requirement" class="formField" formControlName="requirement"
                [ngClass]="{ 'is-invalid': addRequirementForm.get('requirement')?.invalid && addRequirementForm.get('requirement')?.touched }">
                <option [ngValue]="null" disabled selected>Select Requirement</option>
                <option *ngFor="let option of requirementOptions" [value]="option.value">{{ option.label }}</option>
              </select> -->
              <div [matTooltip]="getReqTypeLabel(addRequirementForm.get('requirement')?.value, requirementOptions)"
                matTooltipPosition="above" matTooltipClass="custom-tooltip">
                <p-dropdown inputId="requirement" [options]="requirementOptions" formControlName="requirement"
                  optionLabel="label" optionValue="value"
                  [placeholder]="placeholderMessage['P0149'] || 'Select Requirement'" [filter]="true" filterBy="label"
                  filterMatchMode="contains" styleClass="custom-req-dropdown" [ngClass]="{
                  'is-invalid': addRequirementForm.get('requirement')?.invalid
                  && addRequirementForm.get('requirement')?.touched
                }">
                </p-dropdown>
              </div>
              <div
                *ngIf="addRequirementForm.get('requirement')?.touched && addRequirementForm.get('requirement')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0185'] || 'Requirement is required.'}}
              </div>

            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <!-- <label for="requirement_due_date">Due Date<span class="requiredfield text-danger">*</span></label>
              <p-calendar inputId="requirement_due_date" styleClass="formField" formControlName="dueDate"
                [placeholder]="placeholderMessage['P0147'] || 'Select Due Date'" dateFormat="mm/dd/yy" [showIcon]="true"
                styleClass="custom-due-date-cal"
                [ngClass]="{ 'is-invalid': addRequirementForm.get('dueDate')?.invalid && addRequirementForm.get('dueDate')?.touched }"
                (onSelect)="onRequirementDueDateChange($event)" (keydown)="handleDateInputKeydown($event)">
              </p-calendar>

              <div
                *ngIf="addRequirementForm.get('dueDate')?.touched && addRequirementForm.get('dueDate')?.errors?.['required']"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0198'] || 'Due Date is required.'}}
              </div>
              <div
                *ngIf="addRequirementForm.get('dueDate')?.errors?.['pastDateNotAllowed'] && addRequirementForm.get('dueDate')?.touched"
                class="text-danger mt-1 err-font">
                {{errorMessages['M0199'] || 'Date cannot be earlier than current date.'}}
              </div> -->

              <label for="endorsement_due_date">Due Date<span class="requiredfield text-danger">*</span></label>
              <div class="input-group ssn-input-group calendar-icon-input">
                <input type="text" id="provdueDateInput2" formControlName="dueDate" placeholder="Select Due Date"
                  data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1" maxlength="10"
                  (onSelect)="onProvDueDateChange($event, null, 'prolicreq')"
                  (blur)="onProvDueDateChange(addRequirementForm.get('dueDate')?.value, null, 'prolicreq')"
                  (input)="formatDateInput($event, addRequirementForm.get('dueDate'))" />
                <span class="ssn-eye">
                  <button type="button" class="btn p-0 eye" tabindex="7"
                    (click)="openDatePickerForControl($event, addRequirementForm.get('dueDate'), 'provdueDateInput2', undefined, 'prolicreq')"
                    (keypress)="openDatePickerForControl($event, addRequirementForm.get('dueDate'), 'provdueDateInput2', undefined, 'prolicreq')"
                    title="Open Calendar" aria-label="Open date picker">
                    <span class="material-symbols-outlined f-20 cal">
                      calendar_month
                    </span>
                  </button>
                </span>
              </div>
              <div *ngIf="addRequirementForm.get('dueDate')?.touched && addRequirementForm.get('dueDate')?.errors as errors"
                class="text-danger mt-1 err-font">
                <span *ngIf="errors['required']">Due Date is required.</span>
                <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
                  Enter a valid date in MM/DD/YYYY format.
                </span>
                <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
              </div>
              <div id="dob-error"
                *ngIf="addRequirementForm.get('dueDate')?.touched && addRequirementForm.get('dueDate')?.errors?.['pastDateNotAllowed']"
                class="text-danger mt-1 err-font endorsementerrormsg">
                Date cannot be in the past.
              </div>




            </div>

          </div>
          <div class="row mb-2 fullWidth ml-0 mr-0 mt-2">
            <div class="col pr-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-outline-primary lookup-license-btn-cancel"
                (click)="onCancelAddLicenseRequirement()">Cancel</button>
              <button type="button" class="btn btn-primary ml-2 lookup-license-btn-save"
                (click)="onSaveAddLicenseRequirement()">Save</button>
            </div>
          </div>
        </form>
      </div>

      <div class="tab-content border rounded  p-2 mb-2" style="margin-left:0;margin-right:0;">
        <app-data-grid #licenseRequirementsGrid [config]="licenseRequirementsGridConfig" [activeTab]="'license'"
          [statusDataField]="'status'" [submittedStatusValues]="['Active']"
          [statusColorOverrides]="provReqStatusColorOverrides"
          [inactiveStatusValues]="['Inactive', 'Revoked', 'Suspended']" [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="lookup-user-license-action-buttons-container" [attr.data-row]="rowIndex" role="group">
              <span class="action-span-wrapper edit-wrapper">
                <button type="button" class="action-icon-button" pTooltip="Edit" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip"
                  (click)="onEditLicenseRequirement(data); $event.stopPropagation()">
                  <!-- <i class="fa fa-edit" aria-hidden="true"></i> -->
                  <span class="material-symbols-outlined">edit_square</span>
                </button>
              </span>
              <span class="action-span-wrapper delete-wrapper ml-2">
                <button type="button" class="action-icon-button deletebtn" pTooltip="Delete" tooltipPosition="top"
                  tooltipStyleClass="pcustom-tooltip"
                  (click)="onDeleteLicenseRequirement(data); $event.stopPropagation()">
                  <!-- <i class="fa fa-trash" aria-hidden="true"></i> -->
                  <span class="material-symbols-outlined">delete</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Edit License Kind Modal -->
<ng-template #editLicenseKindModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h4 class="modal-title">Edit Record</h4>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="closeLicenseKindModal()"
        (keypress)="closeLicenseKindModal()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="editLicenseKindForm">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editLicenseType">License Type</label>
          <!-- <select
            id="editLicenseType"
            class="form-control"
            formControlName="licenseType">
            <option value="">Select License Type</option>
            <option *ngFor="let option of licenseTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div [matTooltip]="getSelectLabel(editLicenseKindForm.get('licenseType')?.value, licenseTypeOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editLicenseType" [options]="licenseTypeOptions" formControlName="licenseType"
              optionLabel="label" optionValue="value" placeholder="Select License Type" [filter]="true" filterBy="label"
              styleClass="custom-req-dropdown">
            </p-dropdown>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editLicenseKind">License Kind</label>
          <!-- <select
            id="editLicenseKind"
            class="form-control"
            formControlName="licenseKind">
            <option value="">Select License Kind</option>
            <option *ngFor="let option of licenseKindOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div [matTooltip]="getSelectLabel(editLicenseKindForm.get('licenseKind')?.value, licenseKindOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editLicenseKind" [options]="licenseKindOptions" formControlName="licenseKind"
              optionLabel="label" optionValue="value" placeholder="Select License Kind" [filter]="true" filterBy="label"
              styleClass="custom-req-dropdown">
            </p-dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editEndorsementGrade">Endorsement - Grade</label>
          <!-- <select
            id="editEndorsementGrade"
            class="form-control"
            formControlName="endorsementGrade">
            <option value="">Select Endorsement</option>
            <option *ngFor="let option of endorsementTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div [matTooltip]="getSelectLabel(editLicenseKindForm.get('endorsementGrade')?.value, endorsementTypeOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editEndorsementGrade" [options]="endorsementTypeOptions"
              formControlName="endorsementGrade" optionLabel="label" optionValue="value"
              placeholder="Select Endorsement" [filter]="true" filterBy="label" styleClass="custom-req-dropdown">
            </p-dropdown>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editEndorsementPathway">Endorsement Pathway</label>
          <!-- <select
            id="editEndorsementPathway"
            class="form-control"
            formControlName="endorsementPathway">
            <option value="">Select Endorsement Pathway</option>
            <option *ngFor="let option of endorsementPathwayOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div
            [matTooltip]="getSelectLabel(editLicenseKindForm.get('endorsementPathway')?.value, endorsementPathwayOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editEndorsementPathway" [options]="endorsementPathwayOptions"
              formControlName="endorsementPathway" optionLabel="label" optionValue="value"
              placeholder="Select Endorsement Pathway" [filter]="true" filterBy="label"
              styleClass="custom-req-dropdown">
            </p-dropdown>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4" (click)="onEditLicenseKindReset()"
      [disabled]="editLicenseKindForm.pristine">
      Reset
    </button>
    <button type="button" class="btn btn-primary btn-lg btnprimary" (click)="updateLicenseKindNew()"
      [disabled]="editLicenseKindForm.pristine">
      Update
    </button>
  </div>
</ng-template>

<!-- Edit Combined Provision Modal -->
<ng-template #editCombinedProvisionModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h4 class="modal-title">Edit Record</h4>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="closeEditCombinedProvisionModal()"
        (keypress)="closeEditCombinedProvisionModal()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="editCombinedProvisionForm">
      <div class="row">
        <!-- Category (auto-populated, read-only) -->
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label">Category</label>
          <p-dropdown [options]="provisionCategoryOptions" formControlName="category"
            optionLabel="label" optionValue="value" styleClass="custom-req-dropdown">
          </p-dropdown>
        </div>
        <!-- Provision (options depend on category) -->
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editCombinedProvision">Provision<span
              class="requiredfield text-danger">*</span></label>
          <div [matTooltip]="getSelectLabel(editCombinedProvisionForm.get('provision')?.value, editCurrentProvisionOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editCombinedProvision" [options]="editCurrentProvisionOptions"
              formControlName="provision" optionLabel="label" optionValue="value"
              [placeholder]="placeholderMessage['P0146'] || 'Select Provision'"
              [filter]="true" filterBy="label" (onChange)="onEditCombinedProvisionChange($event)"
              styleClass="custom-req-dropdown"
              [ngClass]="{ 'is-invalid': editCombinedProvisionForm.get('provision')?.invalid && editCombinedProvisionForm.get('provision')?.touched }">
            </p-dropdown>
          </div>
          <div *ngIf="editCombinedProvisionForm.get('provision')?.touched && editCombinedProvisionForm.get('provision')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0184'] || 'Provision is required.'}}
          </div>
        </div>
      </div>
      <div class="row">
        <!-- Source (License Kind or Endorsement based on category) -->
        <div class="col-md-6 mb-3" *ngIf="selectedCombinedProvision?.category">
          <label class="form-label custom-req-label" for="editCombinedSource">Source<span
              class="requiredfield text-danger">*</span></label>
          <p-multiSelect inputId="editCombinedSource" [options]="editSourceOptions"
            formControlName="source"
            [placeholder]="selectedCombinedProvision?.category === 'License Kind' ? (placeholderMessage['P0017'] || 'Select License Kind') : (placeholderMessage['P0018'] || 'Select Endorsement')"
            optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
            [closeOnSelect]="false" display="chip" styleClass="custom-req-muliti-dropdown"
            (onChange)="onCombinedSourceChangeEdit($event)"
            [ngClass]="{ 'is-invalid': editCombinedProvisionForm.get('source')?.invalid && editCombinedProvisionForm.get('source')?.touched }">
          </p-multiSelect>
          <div *ngIf="(editCombinedProvisionForm.get('source')?.touched || editCombinedProvisionForm.get('source')?.dirty) && editCombinedProvisionForm.get('source')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            Source is required.
          </div>
        </div>
        <!-- Due Date -->
        <div class="col-md-6 mb-3">
          <label class="form-label custom-req-label" for="editCombinedDueDate">Due Date<span
              class="requiredfield text-danger">*</span></label>
          <div class="input-group ssn-input-group calendar-icon-input">
            <input type="text" id="editCombinedDueDateInput" formControlName="dueDate" placeholder="MM/DD/YYYY"
              data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1" maxlength="10"
              (blur)="onProvDueDateChange(editCombinedProvisionForm.get('dueDate')?.value, null, selectedCombinedProvision?.category === 'License Kind' ? 'editprolickind' : 'editprolicendo')"
              (input)="formatDateInput($event, editCombinedProvisionForm.get('dueDate'))" />
            <span class="ssn-eye">
              <button type="button" class="btn p-0 eye" tabindex="7"
                (click)="openDatePickerForControl($event, editCombinedProvisionForm.get('dueDate'), 'editCombinedDueDateInput', undefined, selectedCombinedProvision?.category === 'License Kind' ? 'editprolickind' : 'editprolicendo')"
                (keypress)="openDatePickerForControl($event, editCombinedProvisionForm.get('dueDate'), 'editCombinedDueDateInput', undefined, selectedCombinedProvision?.category === 'License Kind' ? 'editprolickind' : 'editprolicendo')"
                title="Open Calendar" aria-label="Open date picker">
                <span class="material-symbols-outlined f-20 cal">calendar_month</span>
              </button>
            </span>
          </div>
          <div *ngIf="editCombinedProvisionForm.get('dueDate')?.touched && editCombinedProvisionForm.get('dueDate')?.errors as errors"
            class="text-danger mt-1 err-font">
            <span *ngIf="errors['required']">{{errorMessages['M0198'] || 'Due Date is required.'}}</span>
            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">Enter a valid date in MM/DD/YYYY format.</span>
            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
          </div>
          <div *ngIf="editCombinedProvisionForm.get('dueDate')?.touched && editCombinedProvisionForm.get('dueDate')?.errors?.['pastDateNotAllowed']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0199'] || 'Date cannot be earlier than current date.'}}
          </div>
        </div>
        <!-- Additional Text -->
        <div class="col-md-6 mb-3">
          <label for="editCombinedAdditionalText" class="form-label">Additional Text<span
              class="requiredfield text-danger">*</span></label>
          <textarea rows="1" cols="30" pInputTextarea class="formField autoheighttextarea mb-0 mt-1"
            formControlName="additionalText" [placeholder]="placeholderMessage['P0148'] || 'Enter additional text'"
            maxlength="100"></textarea>
          <div *ngIf="editCombinedProvisionForm.get('additionalText')?.touched && editCombinedProvisionForm.get('additionalText')?.errors?.['required']"
            class="text-danger mt-1 err-font-textarea">
            {{errorMessages['M0197'] || 'Additional Text is required.'}}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4"
      (click)="onEditCombinedProvisionReset()" [disabled]="editCombinedProvisionForm.pristine">
      Reset
    </button>
    <button type="button" class="btn btn-primary btn-lg btnprimary"
      (click)="updateCombinedProvision()" [disabled]="editCombinedProvisionForm.pristine">
      Update
    </button>
  </div>
</ng-template>

<!-- Edit License Requirement Modal -->
<ng-template #editLicenseRequirementModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h4 class="modal-title">Edit Record</h4>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="closeLicenseRequirementModal()"
        (keypress)="closeLicenseRequirementModal()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="editLicenseRequirementForm">
      <div class="row">
                <div class="col-md-4 relPos mb-3">
          <label class="form-label custom-req-label" for="editRequirementType">Category<span
              class="text-danger">*</span></label>
          <!-- <select
            id="editRequirementType"
            class="form-control"
            formControlName="type"
            (change)="onEditRequirementTypeChange()">
            <option value="">Select Type</option>
            <option *ngFor="let option of requirementTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div [matTooltip]="getSelectLabel(editLicenseRequirementForm.get('type')?.value, requirementTypeOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editRequirementType" [options]="requirementTypeOptions" formControlName="type"
              optionLabel="label" optionValue="value" [placeholder]="placeholderMessage['P0150'] || 'Select Type'"
              (onChange)="onEditRequirementTypeChange()" [filter]="true" styleClass="custom-req-dropdown w-100"
              filterBy="label">
            </p-dropdown>
          </div>

          <div
            *ngIf="editLicenseRequirementForm.get('type')?.touched && editLicenseRequirementForm.get('type')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0186'] || 'Type is required.'}}
          </div>
        </div>

        <div class="col-md-4 relPos mb-3">
          <label class="form-label" for="editLicenseKind">Source<span class="text-danger">*</span></label>

          <p-multiSelect *ngIf="!showEndorsementField" id="editLicenseKind" [options]="getlicenseKindFilterOptions" formControlName="licenseKind"
            optionLabel="label" optionValue="value" [placeholder]="placeholderMessage['P0017'] || 'Select License Kind'"
            display="chip" [filter]="true" filterBy="label" [showClear]="true" [closeOnSelect]="false"
            styleClass="custom-req-muliti-dropdown w-100"
            [disabled]="!editLicenseRequirementForm.get('type')?.value"
            [ngClass]="{ 'is-invalid': editLicenseRequirementForm.get('licenseKind')?.invalid && editLicenseRequirementForm.get('licenseKind')?.touched }"
            (onChange)="onRequirementLicenseKindChangeEdit($event)">
          </p-multiSelect>
          <p-multiSelect *ngIf="showEndorsementField" id="editEndorsement" [options]="getEndorsementTypeFilterOptions" formControlName="endorsement"
            optionLabel="label" optionValue="value" [placeholder]="placeholderMessage['P0018'] || 'Select Endorsement'"
            display="chip" [filter]="true" filterBy="label" [showClear]="true" [closeOnSelect]="false"
            styleClass="custom-req-muliti-dropdown w-100"
            [ngClass]="{ 'is-invalid': editLicenseRequirementForm.get('endorsement')?.invalid && editLicenseRequirementForm.get('endorsement')?.touched }"
            (onChange)="onRequirementEndorsementChangeEdit($event)">
          </p-multiSelect>
          <div
            *ngIf="!showEndorsementField && (editLicenseRequirementForm.get('licenseKind')?.touched || editLicenseRequirementForm.get('licenseKind')?.dirty) && editLicenseRequirementForm.get('licenseKind')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0024'] || 'License Kind is required.'}}
          </div>
          <div
            *ngIf="showEndorsementField && (editLicenseRequirementForm.get('endorsement')?.touched || editLicenseRequirementForm.get('endorsement')?.dirty) && editLicenseRequirementForm.get('endorsement')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0025'] || 'Endorsement is required.'}}
          </div>
        </div>

        <div class="col-md-4 relPos mb-3">
          <label class="form-label custom-req-label" for="editRequirement">Requirement<span
              class="text-danger">*</span></label>
          <!-- <select
            id="editRequirement"
            class="form-control"
            formControlName="requirement">
            <option value="">Select Requirement</option>
            <option *ngFor="let option of requirementOptions" [value]="option.value">{{ option.label }}</option>
          </select> -->
          <div [matTooltip]="getSelectLabel(editLicenseRequirementForm.get('requirement')?.value, requirementOptions)"
            matTooltipPosition="above" matTooltipClass="custom-tooltip">
            <p-dropdown inputId="editRequirement" [options]="requirementOptions" formControlName="requirement"
              optionLabel="label" styleClass="custom-req-dropdown" optionValue="value"
              [placeholder]="placeholderMessage['P0149'] || 'Select Requirement'" [filter]="true" filterBy="label">
            </p-dropdown>
          </div>
          <div
            *ngIf="editLicenseRequirementForm.get('requirement')?.touched && editLicenseRequirementForm.get('requirement')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0185'] || 'Requirement is required.'}}
          </div>
        </div>
        <div class="col-md-4 relPos mb-3">
          <!-- <label class="form-label" for="editRequirementDueDate">Due Date<span class="text-danger">*</span></label>
          <p-calendar inputId="editRequirementDueDate" formControlName="dueDate"
            [placeholder]="placeholderMessage['P0147'] || 'Select Due Date'" dateFormat="mm/dd/yy" [showIcon]="true"
            styleClass="custom-due-date-cal" (keydown)="handleDateInputKeydown($event)"
            [ngClass]="{ 'is-invalid': editLicenseRequirementForm.get('dueDate')?.invalid && editLicenseRequirementForm.get('dueDate')?.touched }"
            (onSelect)="onRequirementDueDateChangeEdit($event)">
          </p-calendar>
          <div
            *ngIf="editLicenseRequirementForm.get('dueDate')?.touched && editLicenseRequirementForm.get('dueDate')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0198'] || 'Due Date is required.'}}
          </div>
          <div
            *ngIf="editLicenseRequirementForm.get('dueDate')?.errors?.['pastDateNotAllowed'] && editLicenseRequirementForm.get('dueDate')?.touched"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0199'] || 'Date cannot be earlier than current date.'}}
          </div> -->

           <label class="form-label custom-req-label" for="editRequirementDueDate">Due Date<span
              class="requiredfield text-danger">*</span></label>
          <div class="input-group ssn-input-group calendar-icon-input">
            <input type="text" id="editDueDateInput2" formControlName="dueDate" placeholder="MM/DD/YYYY"
              data-placeholder="MM/DD/YYYY" class="form-control date-uppercase mt-1" maxlength="10"
              (blur)="onProvDueDateChange(editLicenseRequirementForm.get('dueDate')?.value, null, 'prolicreq')"
              (input)="formatDateInput($event, editLicenseRequirementForm.get('dueDate'))" />
            <span class="ssn-eye">
              <button type="button" class="btn p-0 eye" tabindex="7"
                (click)="openDatePickerForControl($event, editLicenseRequirementForm.get('dueDate'), 'editDueDateInput2', undefined, 'prolicreq')"
                (keypress)="openDatePickerForControl($event, editLicenseRequirementForm.get('dueDate'), 'editDueDateInput2', undefined, 'prolicreq')"
                title="Open Calendar" aria-label="Open date picker">
                <span class="material-symbols-outlined f-20 cal">
                  calendar_month
                </span>
              </button>
            </span>
          </div>
          <div
            *ngIf="editLicenseRequirementForm.get('dueDate')?.touched && editLicenseRequirementForm.get('dueDate')?.errors as errors"
            class="text-danger mt-1 err-font">
            <span *ngIf="errors['required']">{{errorMessages['M0198'] || 'Due Date is required.'}}</span>
            <span *ngIf="errors['invalidDateFormat'] || errors['invalidDate']">
              Enter a valid date in MM/DD/YYYY format.
            </span>
            <span *ngIf="errors['invalidYear']">Enter year between 1900 and 2100.</span>
          </div>
          <div
            *ngIf="editLicenseRequirementForm.get('dueDate')?.touched && editLicenseRequirementForm.get('dueDate')?.errors?.['pastDateNotAllowed']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0199'] || 'Date cannot be earlier than current date.'}}
          </div>

        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4" (click)="onEditLicenseRequirementReset()"
      [disabled]="editLicenseRequirementForm.pristine">
      Reset
    </button>
    <button type="button" class="btn btn-primary btn-lg btnprimary" (click)="updateLicenseRequirement()"
      [disabled]="editLicenseRequirementForm.pristine">
      Update
    </button>
  </div>
</ng-template>

<!-- Due Date Warning Modal -->
<div *ngIf="showDueDateWarningModal" class="due-date-warning-modal custom-due-date-warning-modal">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-warning-header">
        <i class="fa fa-exclamation-triangle warning-icon" aria-hidden="true"></i>
        <h2 class="modal-title">Due Date Notice</h2>

      </div>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDueDateWarningModal()">
        <span aria-hidden="true">&times;</span>
      </button>
      <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDueDateWarningModal()"></button> -->
    </div>
    <div class="modal-body">
      <div class="para-container">
        <!-- <p class="para-content">The Due Date you entered is different from the system-calculated date based on the selected Provision.</p> -->
        <p class="para-content">The selected Due Date differs from the system-calculated date based on business rules.
          You may continue if the selected date is correct.</p>
      </div>
    </div>


    <div class="modal-actions">
      <button class="btn-delete-cancel btn-primary btn-ok" (click)="closeDueDateWarningModal()">OK</button>
    </div>
  </div>
</div>




<!-- Send License by Email Modal -->
<ng-template #sendLicenseByEmailModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title">Send License by Email</h5>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="closeSendLicenseByEmailModal()"
        (keypress)="closeSendLicenseByEmailModal()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body">
    <div class="para-container">
      <p class="para-content">The educator’s license will be emailed to the recipient below.</p>
    </div>

    <form [formGroup]="sendLicenseByEmailForm" novalidate>
      <div class="row">
        <div class="col-sm-12">
          <label class="form-label custom-req-label" for="cansendtootheremailstooText">Recipient Email Address<span
              class="requiredfield text-danger">*</span>
          </label>
          <input type="text" id="cansendtootheremailstooText" class="form-control"
            formControlName="cansendtootheremailstext" maxlength="255"
            [placeholder]="placeholderMessage['P0009'] || 'user@example.com'">
          <div
            *ngIf="sendLicenseByEmailForm.get('cansendtootheremailstext')?.touched && sendLicenseByEmailForm.get('cansendtootheremailstext')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            {{errorMessages['M0014'] || 'Email Address is required.'}}
          </div>
          <div
            *ngIf="sendLicenseByEmailForm.get('cansendtootheremailstext')?.errors?.['pattern'] || sendLicenseByEmailForm.get('cansendtootheremailstext')?.errors?.['maxlength']"
            class="text-danger mt-1 err-font">
            {{ errorMessages['M0015'] || 'Enter a valid email address.' }}
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-reset" (click)="closeSendLicenseByEmailModal()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary btn-update" (click)="sentLicenseByEmail()"
      [disabled]="sendLicenseByEmailForm.invalid">
      Send
    </button>
  </div>
</ng-template>
